import styled from 'styled-components/macro';
import { FlexibleCol } from '@yme/atoms/grid';
import { MiniButton } from '@yme/atoms/mini-button';
import { getTextStyles } from '@yme/utils/styles';
export const MiniButtonStyled = styled(MiniButton) `
  span {
    ${getTextStyles(null, 400, 16, 24)}
  }
`;
export const FlexibleColStyled = styled(FlexibleCol) `
  flex-shrink: 1;
`;
